import React, { useState } from 'react';
import { func } from 'prop-types';

import PopConfirm from '../../../Layout/PopConfirm';

const MarkAsPaid = ({ onConfirm, onCancel }) => {
  const [message, setMessage] = useState('');
  const [hasError, setHasError] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const errorStyles =
    hasError && !isFocused
      ? {
        borderColor: '#FF7A7A',
        backgroundColor: '#F9E0E0',
      }
      : {};

  return (
    <PopConfirm
      confirm="Mark Payment Request as Paid"
      className="pop-confirm"
      confirmButtonText="Mark as Paid"
      cancelButtonText="Close"
      customContent
      noButtonDisable
      description={
        <div>
          <p className="align-left fs-12 m-top-20">How did the customer pay this payment request?</p>
          <input
            className="common_inputStyle w-100-P p-top-8 p-btm-7"
            style={{ float: 'none', ...errorStyles }}
            onChange={({ target }) => setMessage(target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => {
              setHasError(false);
              setIsFocused(false);
            }}
            value={message}
            placeholder="ex. Customer paid in cash at the store"
          />
        </div>
      }
      onConfirm={() => {
        if (message) {
          onConfirm(message);
        } else {
          setHasError(true);
        }
      }}
      onCancel={onCancel}
    />
  );
};

MarkAsPaid.propTypes = {
  onConfirm: func,
  onCancel: func,
};

export default MarkAsPaid;
